import { useTranslation } from 'react-i18next';

import { usersService } from 'authOld/services';
import { ISwitchUsersForm, IUserAutocomplete } from 'authOld/types';
import { objectKeysSnakeCaseToCamelCase } from 'core/utils';
import { Field, Form } from 'coreOld/components';
import { InputType, Size } from 'coreOld/enums';

import {
  MostRecentItem,
  MostRecentItemLink,
  MostRecentLabel,
  MostRecentList,
  MostRecentWrapper,
} from './switchUsersFormStyle';
import { switchUsersSchema } from './switchUsersSchema';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => (data: ISwitchUsersForm) => void;
  chooseUser: (user: IUserAutocomplete) => void;
  selectedUser: IUserAutocomplete | null;
  mostRecentUsers: IUserAutocomplete[];
}

const MIN_WIDTH = 500;

const getUserLabel = (user: IUserAutocomplete) =>
  user && `#${user?.id} ${user?.firstName || ''} ${user?.lastName || ''} (${user?.email})`;

const SwitchUsersFormView = ({
  isOpen,
  onClose,
  onSubmit,
  chooseUser,
  selectedUser,
  mostRecentUsers,
}: IProps) => {
  const { t } = useTranslation();

  const beforeSubmitContent = (
    <MostRecentWrapper>
      <MostRecentLabel>{t('labelMostRecent')}</MostRecentLabel>
      <MostRecentList>
        {mostRecentUsers.length === 0 && (
          <MostRecentItem>{t('messageNoUsersFound')}</MostRecentItem>
        )}

        {mostRecentUsers.map((user) => (
          <MostRecentItem key={user.id}>
            <MostRecentItemLink onClick={() => chooseUser(objectKeysSnakeCaseToCamelCase(user))}>
              {getUserLabel(objectKeysSnakeCaseToCamelCase(user))}
            </MostRecentItemLink>
          </MostRecentItem>
        ))}
      </MostRecentList>
    </MostRecentWrapper>
  );

  return (
    <Form<ISwitchUsersForm>
      isOpen={isOpen}
      onClose={onClose}
      title={t('labelImpersonate')}
      submitBtnLabel={t('buttonLabelImpersonate')}
      defaultValues={{ user: selectedUser ?? undefined }}
      onSubmit={onSubmit}
      schema={switchUsersSchema()}
      loadedDefaultValues={Boolean(selectedUser)}
      beforeSubmitContent={beforeSubmitContent}
      minWidth={MIN_WIDTH}
    >
      <Field
        name="user"
        label={t('labelUser')}
        type={InputType.ASYNC_SELECT}
        inputProps={{
          getOptions: usersService.getManyAutocomplete,
          getLabel: (opt: IUserAutocomplete) => getUserLabel(opt),
          getValue: (opt: IUserAutocomplete) => opt,
          isClearable: false,
          showDropdownIcon: true,
          size: Size.XS,
          autoFocus: true,
        }}
      />
    </Form>
  );
};

export default SwitchUsersFormView;
